// extracted by mini-css-extract-plugin
export default {"questionVoteBox":"n2-z","upvote":"o2-z","downvote":"p2-z","numVotes":"q2-z","votesDescription":"r2-z","report":"s2-z","voted":"t2-z","answerVoteBox":"u2-z","justReported":"v2-z"};